import React, { useState } from "react";
import { ShieldCheck, ShieldAlert, Mail, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api, downloadFile, errMsg, fmtDate } from "@/lib/api";

function RequestButton({ c, onChanged }: { c: any; onChanged: () => void }) {
  const [busy, setBusy] = useState(false);
  const email = c.data?.personal?.email;
  if (!email) return null;
  const sent = c.state_auth_request?.sent_at;
  const go = async () => {
    if (!window.confirm(`Email ${email} a secure link to sign the State Authorization?${sent ? " The earlier link will stop working." : ""}`)) return;
    setBusy(true);
    try { await api.post(`/admin/cases/${c.id}/state-auth-request`); toast.success(`Signing link sent to ${email}`); onChanged(); } catch (e) { toast.error(errMsg(e)); }
    setBusy(false);
  };
  return (
    <span className="inline-flex items-center gap-2 text-xs">
      <button type="button" className="inline-flex items-center gap-1 font-semibold text-[#1B365D] hover:underline disabled:opacity-50" disabled={busy} onClick={go} data-testid="state-auth-request-button">
        {busy ? <Loader2 className="h-3.5 w-3.5 animate-spin" /> : <Mail className="h-3.5 w-3.5" />} {sent ? "Resend signing link" : "Email signing link"}
      </button>
      {sent && <span className="text-[#94A3B8]" data-testid="state-auth-request-sent">Sent {fmtDate(sent)}</span>}
    </span>
  );
}

export function StateAuthBadge({ c, onChanged }: { c: any; onChanged: () => void }) {
  const att = (c.attachments || []).find((a: any) => a.kind === "state_authorization" && !a.is_deleted);
  if (!att && !c.state_auth_required) return null;
  if (!att) {
    return (
      <span className="inline-flex flex-wrap items-center gap-3">
        <span className="inline-flex items-center gap-1.5 rounded-full border border-amber-300 bg-amber-50 px-3 py-1 text-xs font-semibold text-[#B45309]"
          title="This client requires a signed State Authorization, but none is on file (for example, applications submitted before it was added)" data-testid="state-auth-missing-badge">
          <ShieldAlert className="h-3.5 w-3.5" /> No signed State Authorization on file
        </span>
        <RequestButton c={c} onChanged={onChanged} />
      </span>
    );
  }
  return (
    <button type="button" onClick={() => downloadFile(`/admin/cases/${c.id}/attachments/${att.id}`, att.filename).catch((e) => toast.error(errMsg(e)))}
      className="inline-flex items-center gap-1.5 rounded-full border border-emerald-300 bg-emerald-50 px-3 py-1 text-xs font-semibold text-[#15803D] transition-colors hover:bg-emerald-100"
      title="Download the signed State Authorization" data-testid="state-auth-badge">
      <ShieldCheck className="h-3.5 w-3.5" /> Signed State Authorization · {fmtDate(att.at)}
    </button>
  );
}
